// removed by extract-text-webpack-plugin
module.exports = {"ContactData":"ContactData__ContactData__1whvJ","Input":"ContactData__Input__2uU-e"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Checkout/ContactData/ContactData.css
// module id = 142
// module chunks = 0